//The SLN is the little sibling of the IGN, but offers more flexibility for teams to optionally provide all their own content and hook into their own application.
import store from "@/store/index.js";
store.watch(
  () => store.getters["userAccount/getLoginDetails"],
  userData => {
    document.getElementById("SLNavUserName") && document.getElementById("SLNavUserName").innerHTML
      ? (document.getElementById("SLNavUserName").innerHTML = userData.name)
      : null;
    document.getElementById("SLNavUserEmail") && document.getElementById("SLNavUserEmail").innerHTML
      ? (document.getElementById("SLNavUserEmail").innerHTML = userData.userName)
      : null;
    document.getElementById("SLNavUserRole") && document.getElementById("SLNavUserRole").innerHTML
      ? (document.getElementById("SLNavUserRole").innerHTML =
          userData.idTokenClaims && userData.idTokenClaims.roles[0] ? userData.idTokenClaims.roles[0] : "")
      : null;
  }
);

const logo = {
    href: "/exceptions",
    img: {
      src: `${process.env.VUE_APP_PRECONNECT_ASSETS}/integrated-global-nav/2/2.2.14//assets/img/logos/maeu.svg`,
      alt: "Maersk logo",
      width: 175,
      mobileWidth: 100
    }
  },
  header = {
    primary: {
      links: [
        // {
        //   title: "Agent Manifest",
        //   type: "link",
        //   action: {
        //     arguments: "e",
        //     body: "e.preventDefault();"
        //   }
        // },
        // {
        //   title: "Home",
        //   type: "link",
        //   href: "/",
        //   action: {
        //     arguments: "e",
        //     body: "e.preventDefault();"
        //   }
        // },
        {
          title: "Exceptions",
          type: "link",
          href: "/exceptions"
        },
        // {
        //   title: "Port mismatch",
        //   type: "link",
        //   href: "/port-mismatch"
        // },
        {
          title: "Manifest",
          type: "link",
          href: "/manifest"
        },
        // {
        //   title: "Vessel Voyage",
        //   type: "link",
        //   href: "/vessel-voyage",
        //   action: {
        //     arguments: "e",
        //     body: "e.preventDefault();"
        //   }
        // },
        {
          title: "Consignment",
          type: "link",
          href: "/consignment"
        },
        {
          title: "Port Call",
          type: "link",
          href: "/port-call"
        },
        {
          title: "Releases",
          type: "link",
          href: "/releases",
          submenu: {
            links: [
              { title: "Container release", href: "/releases/container-releases" },
              { title: "Inbond release", href: "/releases/inbond-releases" }
            ]
          }
        },
        {
          title: "Notification Centre",
          type: "link",
          href: "/notification"
        },
        {
          type: "menu",
          href: "#sln-footer",
          icon: "menu",
          title: "Menu",
          dataId: "sln-panel__navigation",
          push: "s,m,l"
        }
      ]
    },
    navigation: {
      id: "navigation",
      columns: [
        {
          lists: [
            {
              links: [
                {
                  type: "account",
                  title: "Name",
                  classes: "sln-header__account__link__label sln-header__panel__link",
                  action: {
                    arguments: "e",
                    body: "e.preventDefault();"
                  }
                },
                {
                  type: "account",
                  title: "Loading...",
                  id: "SLNavUserName",
                  action: {
                    arguments: "e",
                    body: "e.preventDefault();"
                  }
                },
                {
                  type: "account",
                  title: "Username",
                  classes: "sln-header__account__link__label sln-header__panel__link",
                  action: {
                    arguments: "e",
                    body: "e.preventDefault();"
                  }
                },
                {
                  type: "account",
                  title: "Loading...",
                  id: "SLNavUserEmail",
                  action: {
                    arguments: "e",
                    body: "e.preventDefault();"
                  }
                },
                {
                  type: "account",
                  title: "Customer Role",
                  classes: "sln-header__account__link__label sln-header__panel__link",
                  action: {
                    arguments: "e",
                    body: "e.preventDefault();"
                  }
                },
                {
                  type: "account",
                  title: "Loading...",
                  id: "SLNavUserRole",
                  action: {
                    arguments: "e",
                    body: "e.preventDefault();"
                  }
                },
                {
                  type: "account",
                  title: "Agent Manifest Version 2320.01",
                  classes: "sln-header__version_details",
                  action: {
                    arguments: "e",
                    body: "e.preventDefault();"
                  }
                }
              ]
            }
          ]
        }
      ]
    }
  },
  footer = {
    copyright: `@ A.P. Moller - Maersk`,
    columns: [
      {
        links: [
          {
            title: "Terms & conditions",
            href: "https://terms.maersk.com/",
            target: "_blank"
          }
        ]
      },
      {
        links: [
          {
            title: "Privacy policy",
            href: "https://www.maersk.com/privacy-policy",
            target: "_blank"
          }
        ]
      }
    ],
    social: {
      links: [
        {
          title: "LinkedIn",
          href: "https://www.linkedin.com/company/maersk-group/",
          target: "_blank",
          rel: "noreferrer",
          private: true
        },
        {
          title: "Facebook",
          href: "https://www.facebook.com/Maersk",
          target: "_blank",
          rel: "noreferrer"
        },
        {
          title: "Twitter",
          href: "https://twitter.com/Maersk",
          target: "_blank",
          rel: "noreferrer"
        },
        {
          title: "Instagram",
          href: "https://www.instagram.com/maersk_official",
          target: "_blank",
          rel: "noreferrer"
        },
        {
          title: "YouTube",
          href: "https://www.youtube.com/channel/UCZiaSUekMl9qG7FBn4rNZ9Q",
          target: "_blank",
          rel: "noreferrer"
        }
      ]
    }
  };

const config = {
  logo,
  header,
  footer,
  labels: {
    back: "Back",
    close: "Close"
  }
};

export const IGN_NAV_STATE = process.env.VUE_APP_IGN_NAV;

export const loadSLN = () => {
  window.slnConfig = { ...(IGN_NAV_STATE === "disable" ? config : "") };
};
